import { record } from '@root/src/web/browser/ophan/ophan';
const recordMessageTimeoutInOphan = (messageId, slotName) => record({
    component: `${slotName}-picker-timeout-dcr`,
    value: messageId,
});
const timeoutify = (candidateConfig, slotName) => {
    let timer;
    const canShow = () => new Promise((resolve) => {
        if (candidateConfig.timeoutMillis) {
            timer = window.setTimeout(() => {
                recordMessageTimeoutInOphan(candidateConfig.candidate.id, slotName);
                resolve({ result: false });
            }, candidateConfig.timeoutMillis);
        }
        candidateConfig.candidate
            .canShow()
            .then((result) => resolve(result));
    });
    const cancelTimeout = () => timer && clearTimeout(timer);
    return {
        ...candidateConfig,
        candidate: {
            ...candidateConfig.candidate,
            canShow,
        },
        cancelTimeout,
    };
};
const clearAllTimeouts = (messages) => messages.map((m) => m.cancelTimeout());
const defaultShow = () => null;
export const pickMessage = ({ candidates, name, }) => new Promise((resolve) => {
    const candidateConfigsWithTimeout = candidates.map((c) => timeoutify(c, name));
    const results = candidateConfigsWithTimeout.map((c) => c.candidate.canShow());
    const winner = results.reduce(async (winningMessageSoFar, canShow, idx) => {
        const runningIdx = (await winningMessageSoFar).idx;
        if (runningIdx >= 0) {
            return winningMessageSoFar;
        }
        const result = await canShow;
        candidateConfigsWithTimeout[idx].cancelTimeout();
        if (result.result) {
            return { idx, meta: result.meta };
        }
        return winningMessageSoFar;
    }, Promise.resolve({ idx: -1 }));
    winner.then(({ idx, meta }) => {
        clearAllTimeouts(candidateConfigsWithTimeout);
        resolve(idx === -1
            ? defaultShow
            : () => candidateConfigsWithTimeout[idx].candidate.show(meta));
    });
});
